module.exports = __webpack_public_path__ + "img/155.a86f70d0.jpg";